import { Container } from "./styles/styled";

const LoadingModal = () => {
  return (
    <Container>
      <div className="popup-container-background">
        <div className="delete-exercise-popup-container loader">
          <h1>Loading...</h1>
          <iframe src="https://lottie.host/embed/8b06c342-d3f3-4d38-8fc4-cdef020eccd2/cJz4qYvfv0.lottie"></iframe>
        </div>
      </div>
    </Container>
  );
};
export default LoadingModal;
